import { Action } from '@ngrx/store';

export class StructuredProductsAction implements Action {
    public static getClientCustodiesSuccess: string =
        '[Structured Products] getClientCustodiesSuccess';

    constructor(public type: string, public payload?: any) {}
}
